/**
 * SupportMediaToolbar — the row of quick-attach buttons under the chat
 * composer of SupportWidget (screenshot / video / voice / file), plus the
 * hidden file input they open.
 *
 * Extracted verbatim from SupportWidget.jsx (refactor, no behavior change).
 * The file input ref stays local — SupportWidget never reads it, only
 * triggers a pick indirectly (button click → hidden input click) and
 * receives the resulting FileList via onPickFiles.
 */
import { useRef } from 'react'
import { Camera, Mic, Paperclip, Video } from 'lucide-react'

export default function SupportMediaToolbar({
    disabled,
    onScreenshot,
    onRecordVideo,
    onRecordAudio,
    onPickFiles,
}) {
    const fileInputRef = useRef(null)

    return (
        <div className="row-center-8" style={{ padding: '0 14px 4px', flexWrap: 'wrap' }}>
            <button
                type="button"
                className="btn btn--secondary btn--sm row-center-6"
                onClick={onScreenshot}
                disabled={disabled}
                title="Скриншот текущего экрана (с авто-маской персональных данных)"
            >
                <Camera size={14} /> Скриншот
            </button>
            <button
                type="button"
                className="btn btn--secondary btn--sm row-center-6"
                onClick={onRecordVideo}
                disabled={disabled}
                title="Записать видео экрана"
            >
                <Video size={14} /> Видео
            </button>
            <button
                type="button"
                className="btn btn--secondary btn--sm row-center-6"
                onClick={onRecordAudio}
                disabled={disabled}
                title="Записать голосовое сообщение"
            >
                <Mic size={14} /> Голос
            </button>
            <button
                type="button"
                className="btn btn--secondary btn--sm row-center-6"
                onClick={() => fileInputRef.current?.click()}
                disabled={disabled}
                title="Приложить картинку, видео (до 500 МБ), голос или файл"
            >
                <Paperclip size={14} /> Файл
            </button>
            <input
                ref={fileInputRef}
                type="file"
                accept="image/*,video/*,audio/*,.pdf,.csv,.txt,.json,.zip"
                multiple
                onChange={onPickFiles}
                style={{ display: 'none' }}
            />
        </div>
    )
}
